import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertCircle, LogOut, Mail, RefreshCw } from 'lucide-react';

const NoAccessPage = () => {
  const { user, logout } = useAuth();
  
  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="no-access-page">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-yellow-500/10 rounded-full flex items-center justify-center mb-4">
            <AlertCircle className="w-8 h-8 text-yellow-500" />
          </div>
          <CardTitle className="text-xl">Access Pending</CardTitle>
          <CardDescription>
            Your account is awaiting approval from an administrator
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-muted p-4 rounded-lg space-y-2">
            <p className="text-sm text-muted-foreground">
              <strong>Account:</strong> {user?.email}
            </p>
            <p className="text-sm text-muted-foreground">
              <strong>Status:</strong> Pending Approval
            </p>
          </div>
          
          <p className="text-sm text-center text-muted-foreground">
            Please contact your administrator to request access to the CRM system.
            Once your role is assigned, you will be able to access the relevant features.
          </p>
          
          <div className="flex gap-2">
            <Button onClick={handleRefresh} variant="outline" className="flex-1">
              <RefreshCw size={16} className="mr-2" />
              Check Again
            </Button>
            <Button onClick={handleLogout} variant="destructive" className="flex-1">
              <LogOut size={16} className="mr-2" />
              Sign Out
            </Button>
          </div>
          
          <div className="text-center">
            <a 
              href="mailto:admin@treppanliving.ae" 
              className="text-sm text-primary hover:underline flex items-center justify-center gap-1"
            >
              <Mail size={14} />
              Contact Administrator
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NoAccessPage;
